import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import { Container, Typography, Link } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

function EsperanceVie() {
  return (
    <div style={{ backgroundColor: '#f5f5f5', paddingBottom: '40px' }}>
      <NavigationBar />
             <Container maxWidth="lg" style={{ paddingTop: '60px' }}>
        <Typography variant="h4" align="justify" gutterBottom style={{ color: '#388E3C' }}>
          Espérance de Vie à la Naissance au Burundi 
        </Typography>
        
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333' }}>
          L'espérance de vie à la naissance est un indicateur essentiel de santé. Au Burundi, elle pourrait dépasser 68 ans d'ici 2050, avec une estimation actuelle de <strong>60,6 ans</strong> en 2023, contre environ 60 ans en 2010.
        </Typography>

        <Typography variant="h6" gutterBottom style={{ color: '#388E3C' }}>
          Détails
        </Typography>
        <ul style={{ paddingLeft: '20px', color: '#333' }}>
          <li><strong>66,3 ans pour les hommes</strong></li>
          <li><strong>71,2 ans pour les femmes</strong></li>
        </ul>

        <Typography variant="h6" gutterBottom style={{ color: '#388E3C', marginTop: '20px' }}>
          Taux de mortalité infantile
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333' }}>
          En 2024, le taux de mortalité infantile est de <strong>63,5 pour mille</strong>.
        </Typography>
          <Typography variant="body1" align="left" paragraph sx={{ color: '#333' }}>
                        <strong>Source:</strong> 
                        <Link href="/documents/rapports/Rapport_Projections-_2016.pdf" target="_blank" sx={{ color: '#d32f2f', fontWeight: 'bold' }}>
                        {<DownloadIcon />} Projection démographique 2010-2050
                        </Link>
        </Typography>
      </Container>
      <Footer />
    </div>
  );
}

export default EsperanceVie;